import { DefaultPopover, ToggleOptionGroup, ToggleOptionGroupItem, DefaultTooltip } from "twyne-new.ui"

import { useCraftProp } from "../../utils"

import { Icon } from "."

const Transform = () => {
  const { value: textTransform, setValue: setTextTransform } = useCraftProp('transform')

  return <DefaultPopover
    trigger={<ToggleOptionGroup size='lg' value={textTransform ? 'default' : ''} type='single'>
      <ToggleOptionGroupItem value='default'>
        <DefaultTooltip content={<TransformTrigger textTransform={textTransform} />}>
          {!textTransform ? <Icon value='CaseLower' size='14' /> : <Icon value={TEXT_TRANSFORM_OPTIONS[textTransform].icon} />}
        </DefaultTooltip>
      </ToggleOptionGroupItem>
    </ToggleOptionGroup>}
    triggerProps={{ asChild: true }}
    contentProps={{ className: 'p-0 w-12', side: 'bottom', align: 'center' }}
  >
    <ToggleOptionGroup size='lg' value={textTransform || ''} onValueChange={setTextTransform} type='single' className='flex flex-col gap-1'>
      {Object.entries(TEXT_TRANSFORM_OPTIONS).map(([key, value]) => <ToggleOptionGroupItem key={key} value={key}>
        <DefaultTooltip content={value.tooltip}>
          <Icon value={value.icon} />
        </DefaultTooltip>
      </ToggleOptionGroupItem>,
      )}
    </ToggleOptionGroup>
  </DefaultPopover>
}

const TransformTrigger = ({ textTransform }) => <>
  <div>Text transform</div>
  {textTransform && <div className='text-sm font-bold mt-1'>{TEXT_TRANSFORM_OPTIONS[textTransform]?.tooltip}</div>}
</>

const TEXT_TRANSFORM_OPTIONS = {
  uppercase: {
    icon: 'CaseUpper',
    tooltip: 'Uppercase',
  },
  lowercase: {
    icon: 'CaseLower',
    tooltip: 'Lowercase',
  },
  capitalize: {
    icon: 'CaseSensitive',
    tooltip: 'Capitalize',
  },
  'normal-case': {
    icon: 'CaseLower',
    tooltip: 'Normal Case',
  },
}

export default Transform
